import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDeleteTimeOff } from "@/features/calendar/hooks/use-timeoffs";
import type { TimeOff } from "@/features/calendar/types";
import {
  DotsThreeOutlineIcon,
  PencilSimple,
  Trash,
} from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "@/features/utils/i18n";
import { toast } from "sonner";
import { EditTimeOffDialog } from "./edit-timeoff-dialog";

export const Action = ({ timeoff }: { timeoff: TimeOff }) => {
  const { t } = useTranslation("schedules");
  const deleteTimeOff = useDeleteTimeOff();
  const [isEditOpen, setIsEditOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await deleteTimeOff.mutateAsync(timeoff.id);
      toast.success(t("closures.messages.deleted"));
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : t("closures.messages.deleteError"),
      );
    }
  };

  return (
    <>
      <div className="text-right flex items-center justify-end gap-2">
        <Button variant="ghost" size="icon" onClick={() => setIsEditOpen(true)}>
          <PencilSimple className="h-4 w-4" weight="fill" />
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">{t("common.openMenu")}</span>
              <DotsThreeOutlineIcon weight="fill" className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem className="p-0">
              <Button
                variant="ghost"
                onClick={handleDelete}
                className="w-full justify-start text-destructive hover:text-destructive"
                confirm={t("closures.messages.deleteConfirm")}
              >
                <Trash className="h-4 w-4" weight="fill" />
                {t("common.delete")}
              </Button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <EditTimeOffDialog
        timeoff={timeoff}
        open={isEditOpen}
        onOpenChange={setIsEditOpen}
      />
    </>
  );
};
